import Content from "./Content";
import contentStyles from "./Content.styles";
import type { ContentAdapterProps } from "./Content.d";

export { Content, contentStyles };
export type { ContentAdapterProps };
